import { DefaultContentBody } from "dc-delivery-sdk-js"
import { ColorPicker } from "./base"
import { ImageGroup } from "../cms"
import { UseFormReturn } from "react-hook-form"
import { Field as FieldType } from "../forms"
import { AddressDetails } from "../loqate"
import { useCompetitionMarketingFormFields } from "../../hooks/forms/useCompetitionMarketingFormFields"

export interface CompetitionMarketingFormStepperContent extends DefaultContentBody {
  stepperFunctionality: boolean
  stepperForm?: StepperFormContent
}

interface MarketingFormQuestionnaireQuestions {
  question1?: string
  question2?: string
  question3?: string
}

export interface MarketingFormQuestionnaire extends MarketingFormQuestionnaireQuestions {
  includeQuestionnaire: boolean
  question1MaxLength?: number
  question2MaxLength?: number
  question3MaxLength?: number
}

export interface CompetitionMarketingFormCmsContent extends DefaultContentBody {
    titleColor: ColorPicker
    formFields: AvailableMarketingFormFields
    title: string
    description: string
    questionnaire:  MarketingFormQuestionnaire
    stepper?: CompetitionMarketingFormStepperContent
    formCheckboxes: CompetitionMarketingFormCheckboxes
    formEntryMessages: CompetitionMarketingFormEntryMessages
    formConfiguration: CompetitionMarketingFormConfiguration
    formType?: 'Page' | 'Banner' | 'Modal'
  }

export interface CompetitionMarketingFormFieldsProps extends AvailableMarketingFormFields {
  form: UseFormReturn<CompetitionMarketingFormFields>
  formCheckboxes: CompetitionMarketingFormCheckboxes
  questionnaire: MarketingFormQuestionnaire
  stepperMode?: boolean
  currentStep?: number
  stepConfig?: StepConfiguration
  stepContent?: StepperFormContent
}

export interface StepConfiguration {
  steps: Array<{
    fields: string[]
    subText?: string | string[]
    label?: string
  }>
  totalSteps: number
}

export interface AddressFieldWithHiddenInputsProps {
  field: FieldType
  form: UseFormReturn<CompetitionMarketingFormFields>
  applyAddressToFormMarketing: (address: AddressDetails) => void
  hasError: boolean
  subtext?: string
}

export interface CheckboxesForCompetitionMarketingFormProps {
  form: UseFormReturn<CompetitionMarketingFormFields>
  formCheckboxes: CompetitionMarketingFormCheckboxes
}
export interface CompetitionMarketingFormFields extends MarketingFormQuestionnaireQuestions {
  email: string
  firstname?: string
  lastname?: string
  phone?: string
  address?: string
  marketingPermission1?: boolean
  marketingPermission2?: boolean
  searchForAddress?: string
  address1: string
  address2?: string
  city: string
  postalCode: string
}

export interface CompetitionMarketingFormCheckboxes {
  displaySecondCheckbox: boolean
  displayTermsAndConditionsLink: boolean
  firstCheckbox: {
    firstCheckboxDescription: {
      description: string
    }
  }
  secondCheckboxDescription: {
    description: string
  }
}

export interface CompetitionMarketingFormConfiguration {
  reason: string
  formClosingDate: string
}

export interface CompetitionMarketingFormEntryMessages {
  failedSubmissionDescription: string
  failedSubmissionTitle: string
  previouslySubmittedDescription: string
  previouslySubmittedTitle: string
  successIcon: ImageGroup
  successMessageDescription: string
  successMessageTitle: string
  endedMessageTitle: string
  endedMessageDescription: string
}

export enum MarketingFormViewState {
  INITIAL = 'initial',
  SUCCESS = 'success',
  ENDED = 'ended',
  ERROR = 'error'
}

interface AvailableMarketingFormFields {
    name?: boolean
    phoneNumber?: boolean
    address?: boolean
}


export interface CompetitionMarketingFormCmsContent extends DefaultContentBody {
  titleColor: ColorPicker
  formFields: AvailableMarketingFormFields
  title: string
  description: string
  formCheckboxes: CompetitionMarketingFormCheckboxes
  formEntryMessages: CompetitionMarketingFormEntryMessages
  formConfiguration: CompetitionMarketingFormConfiguration
}

export interface CompetitionMarketingFormContentProps extends CompetitionMarketingFormCmsContent {
  isModal: boolean
  state: MarketingFormViewState
  handleClose: () => void
  onSubmit?: React.FormEventHandler
  form: UseFormReturn<CompetitionMarketingFormFields>
  currentStep?: number
  totalSteps?: number
  onNext?: () => Promise<void>
  onBack?: () => void
  isLastStep?: boolean
  isValidating?: boolean
  stepConfig?: StepConfiguration
  onManualSubmit?: () => Promise<void>
  isSubmitting?: boolean
}

export interface Steps {
  fields: string[]
  subText?: string | (string | undefined)[]
  label?: string
  usePreviousHeading?: boolean
}

export interface StepFieldsProps {
  fieldName: string
  fields: ReturnType<typeof useCompetitionMarketingFormFields>
  form: UseFormReturn<CompetitionMarketingFormFields>
  formCheckboxes: CompetitionMarketingFormCheckboxes
  showTermsAndConditionsLink: boolean
  applyAddressToFormMarketing: (address: AddressDetails) => void
  stepContent?: StepperFormContent
  subText?: string | string[]
  label?: string
}

export interface StepperFormContent extends DefaultContentBody {
    page1Subheading?: string
    page2Heading?: string
    page2Subheading?: string
    page3Heading?: string
    page3Subheading?: string
    page4Heading?: string
    page4Subheading?: string
    stepperFormSubtext: {
      addressFieldSubtext?: string
      emailFieldSubtext?: string
      nameFieldSubtext?: string
      phoneFieldSubtext?: string
    }
}